module.exports = __webpack_public_path__ + "static/media/teacher_clicker_info.fe77a533.png";